var map = {
	"./chat/ChatMessage.js": "a299",
	"./games/case-battles/CaseBattlesGame.js": "36a4",
	"./games/cases/CasesGame.js": "7b33",
	"./games/coinflip/CoinflipGame.js": "2652",
	"./games/spinners/SpinnersGame.js": "4d18",
	"./games/wheel/WheelPlayer.js": "74a6",
	"./user/Item.js": "7657",
	"./user/Notification.js": "89b7",
	"./user/Trade.js": "4497",
	"./user/User.js": "d0c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8d5d";